import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as contactActions from './../../actions/contactActions';

import ContactList from './ContactList';

class ContactHome extends React.Component {

   componentDidMount() {
      this.props.actions.loadAllContact();
   }

   render() {
      const { contacts } = this.props;
      return (
         <div>
            <ContactList contacts={contacts} />
         </div>
      );
   }
}

ContactHome.propTypes = {
   actions: PropTypes.object.isRequired,
   contacts: PropTypes.array.isRequired
};


function mapStateToProps(state) {
   return {
      contacts: state.contacts
   };
}

function mapDispatchToProps(dispatch) {
   return {
      actions: bindActionCreators(contactActions, dispatch)
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(ContactHome);



/** WEBPACK FOOTER **
 ** ./src/components/Contact/ContactHome.js
 **/